import React, { useRef } from 'react'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from '../../constants/locale/Namespace'
import FormProperties from './CiFormFormProperties'
import CiFormFieldsPlaceholder from './CiFormFieldsPlaceholder'
import { FormProvider, useForm, useFormContext } from 'react-hook-form'
import _ from 'lodash'
import { Box, Card, Divider, Grid } from '@material-ui/core'
import useCustomYupValidationResolver from 'src/components/aciacehighway/hooks/useCustomYupValidationResolver'

const {
  button: { CngButton }
} = components

const { initialValues, makeValidationSchema } = FormProperties.formikProps

function CiFormSection({setCiFormDirty}) {
  const generatedIndex = useRef(0)
  const { getValues, setValue, watch } = useFormContext()

  const ciForm = watch('ciForm')

  function handleAddCiForm(data) {
    const ciForm = [...getValues('ciForm'), data]

    setValue('ciForm', ciForm, { shouldDirty: true })
    setCiFormDirty(true)
  }

  function handleDeleteCiForm(index) {
    const ciForm = [...getValues('ciForm')]

    ciForm.splice(index, 1)

    setValue('ciForm', ciForm, { shouldDirty: true })
    setCiFormDirty(true)
  }

  function handleEditCiForm(index, data) {
    const ciForm = [...getValues('ciForm')]

    ciForm[index] = data

    setValue('ciForm', ciForm, { shouldDirty: true })
    setCiFormDirty(true)
  }

  return (
    <Card variant='outlined'>
      <Box padding={2}>
        <Grid container spacing={2}>
          {_.isEmpty(ciForm) ? (
            <Grid item xs={12}>
              <CiFormFieldsPlaceholder onAdd={handleAddCiForm} />
            </Grid>
          ) : (
            ciForm.map((item, index) => (
              <React.Fragment key={++generatedIndex.current}>
                <Grid item xs={12}>
                  <CiFormEntry
                    ciForm={item}
                    onDelete={() => handleDeleteCiForm(index)}
                    onEdit={(data) => handleEditCiForm(index, data)}
                  />
                </Grid>
                {index + 1 !== ciForm.length && (
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                )}
              </React.Fragment>
            ))
          )}
        </Grid>
      </Box>
    </Card>
  )
}

function CiFormEntry(props) {
  const { ciForm, onDelete, onEdit } = props

  const { translate } = useTranslation(Namespace.N_B_C_I_CANADA_INVOICE)
  const methods = useForm({
    defaultValues: ciForm,
    resolver: useCustomYupValidationResolver(makeValidationSchema(translate))
  })
  const {
    formState: { isDirty }
  } = methods

  function handleEditCiForm(data) {
    methods.reset(data)
    onEdit(data)
  }

  return (
    <FormProvider {...methods}>
      <Grid alignItems='center' container spacing={1}>
        <Grid item xs={12}>
          <FormProperties.Fields />
        </Grid>
        <Grid item xs={12}>
          <Grid justify='flex-end' container spacing={1}>
            {isDirty ? (
              <>
                <Grid item xs='auto'>
                  <CngButton
                    color='secondary'
                    onClick={() => methods.reset()}
                    size='medium'
                  >
                    Reset
                  </CngButton>
                </Grid>
                <Grid item xs='auto'>
                  <CngButton
                    color='primary'
                    onClick={methods.handleSubmit(handleEditCiForm)}
                    size='medium'
                  >
                    Save changes
                  </CngButton>
                </Grid>
              </>
            ) : (
              <Grid item xs='auto'>
                <CngButton
                  color='primary'
                  onClick={() => onDelete(ciForm)}
                  size='medium'
                >
                  Remove
                </CngButton>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </FormProvider>
  )
}

export default CiFormSection
